(function() {
    const archiveEl = document.querySelector('.jsTrainingAdviseArchive');
    let archiveGrid = null;
    let searchTimeout = null;
    let searchQuery = '';

    if (archiveEl) {
        archiveGrid = archiveEl.querySelector('.jsArchiveGrid');

        const materialFilterEl = archiveEl.querySelector('.jsMaterialTypeFilter');
        if (materialFilterEl) {
            const materialSelect = new SeSelect(materialFilterEl, 'material');
            materialSelect.setActiveOptions(activeMaterialTypes);

            materialSelect.addChangeEventListener(newOptions => {
                activeMaterialTypes = Object.keys(newOptions);
                updateGrid();
            });
        }

        const workfieldFilterEl = archiveEl.querySelector('.jsWorkfieldFilter');
        if (workfieldFilterEl) {
            const workfieldSelect = new SeSelect(workfieldFilterEl, 'workfield');
            workfieldSelect.setActiveOptions(activeWorkfields);

            workfieldSelect.addChangeEventListener(newOptions => {
                activeWorkfields = Object.keys(newOptions);
                updateGrid();
            });
        }

        const themeFilterEl = archiveEl.querySelector('.jsThemeFilter');
        if (themeFilterEl) {
            const themeSelect = new SeSelect(themeFilterEl, 'theme');
            themeSelect.setActiveOptions(activeThemes);

            themeSelect.addChangeEventListener(newOptions => {
                activeThemes = Object.keys(newOptions);
                updateGrid();
            });
        }

        const searchFormEl = archiveEl.querySelector('.jsSearchFilter');
        if (searchFormEl) {
            const searchInputEl = searchFormEl.querySelector('input');

            searchFormEl.addEventListener('submit', e => {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });

            searchInputEl.addEventListener('keyup', e => {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });
        }
    }

    function userDidSearch(query) {
        searchQuery = query;

        // Update the URL
        const url = new Url;

        if (searchQuery) url.query.search = searchQuery;
        else delete url.query.search;

        history.pushState(null, null, url.toString());

        // Set a timeout
        if (searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(_ => updateGrid(), 500);
    }

    function updateGrid() {
        const params = {
            action: 'get_training_advise_grid_html',
            activeMaterialTypes: activeMaterialTypes,
            activeWorkfields: activeWorkfields,
            activeThemes: activeThemes,
            searchQuery: searchQuery
        };

        se_postRequest(se_ajax.ajaxurl, params, response => {
            response = JSON.parse(response);

            if (!response.err) {
                archiveGrid.innerHTML = response.html;
            }
            else {
                alert('Oops.. Something went wrong. Please reload the page and try again.');
                return;
            }

        }, _ => {
            alert('Oops.. Something went wrong. Please reload the page and try again.');
            return;
        });
    }
})();
